import { styled } from '@clickcease/cc-client-components-lib'

export const LoginCard = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '487px',

  '@bp1': {
    width: '295px',
    padding: '0px',
    height: 'auto',
  },
})

export const MarginWrapper = styled('div', {
  marginBottom: '$12',
  width: '400px',

  '@bp1': {
    marginBottom: '$8',
    width: '295px',
  },
})

export const MarginWrapperSmall = styled('div', {
  marginBottom: '$5',
  width: '400px',

  '@bp1': {
    marginBottom: '$8',
    width: '295px',
  },
})

export const LoginTitle = styled('div', {
  fontSize: '32px',
  fontWeight: '700',
  textAlign: 'center',
  '@bp1': { fontSize: '$h2', fontWeight: '600' },
})

export const Or = styled('span', {
  fontWeight: '$r',
  fontSize: '$md',
  color: '$mainTextColor',
  marginBlock: '$5',

  '@bp1': {
    marginBlock: '$8',
  },
})

export const LoginDescription = styled('div', {
  fontSize: '$h1',
  fontWeight: '$l',
  textAlign: 'center',
  margin: '8px 0px 40px 0px',
  '@bp1': {
    fontSize: '$lg',
  },
})

export const DontHaveAnAccount = styled('div', {
  color: '$textColor',
  fontWeight: '$l',
  textAlign: 'center',
})

export const ForgotPassword = styled('div', {
  color: '$textColor',
  marginInline: '5px',
  fontSize: '$lg',
  fontWeight: '$l',
})

export const Reset = styled('button', {
  all: 'unset',
  color: '$primaryColor',
  marginInline: '5px',
  fontSize: '$lg',
  fontWeight: '$b',
  cursor: 'pointer',
})

export const LoginErrorWrapper = styled('div', {
  height: '30px',
  marginTop: '16px',
})

export const LoginNoSubscriptionError = styled('div', {
  color: '$error',
  fontSize: '$md',
})

export const LoginNoSubscriptionErrorLink = styled('span', {
  textDecoration: 'underline',
  cursor: 'pointer',
})

export const LoginWrapperSmall = styled('div', {
  fontWeight: '$r',
  fontSize: '$sm',
  color: '$error',
  marginTop: '5px',
})

export const LoginErrorSmall = styled('span', {
  fontWeight: '$r',
  fontSize: '$sm',
  color: '$error',
})

export const SignUpLink = styled('span', {
  color: '$primaryColor',
  marginInline: '5px',
  fontSize: '$lg',
  fontWeight: '$b',
  cursor: 'pointer',
})

export const GoogleSsoButton = styled('div', {})

export const LoginError = styled('span', {
  fontWeight: '$r',
  fontSize: '$md',
  color: '$error',
})

export const GoogleSsoError = styled('div', {
  color: '$error',
  fontSize: '$md',
  marginTop: '10px',
  fontWeight: '$rb',
})

export const SocialLogin = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  width: '100%',

  variants: {
    noBorder: {
      true: {
        border: 'none',
      },
    },
  },

  '@bp1': {},
})
